module.exports = __webpack_public_path__ + "static/media/default.27ae13fd.png";